module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"bam-browser-sdk","commonjs":"bam-browser-sdk","commonjs2":"bam-browser-sdk","root":"bam-browser-sdk"}
// module id = 1
// module chunks = 0